import makeApiCall from "./master/axiosIndex";
// TO DO Update endpoints
export const tasksApis = {
  createNewTask: (data: any): Promise<any> =>
    makeApiCall({ url: "/task/create", method: "post", data }),
  createSubTask: (data: any): Promise<any> =>
    makeApiCall({ url: "/subtask/create", method: "post", data }),
  updateTaskbyId: (data: any): Promise<any> =>
    makeApiCall({ url: "/task/update", method: "put", data }),
  archiveTask: (taskId: number): Promise<any> =>
    makeApiCall({ url: `/task/archive/${taskId}`, method: "patch" }),

  //TODO listTasks:
  listTasks: (params: any): Promise<any> =>
    makeApiCall({
      url: `/task/list`,
      method: "get",
      params,
    }),
  subTasksList: (params: any): Promise<any> =>
    makeApiCall({
      url: `/subtask/list`,
      method: "get",
      params,
    }),

  priorityList: (params?: any): Promise<any> =>
    makeApiCall({
      url: "/masters/prioritiesList",
      method: "get",
      params,
    }),
  fetchActivityBoqs: (activityId: string): Promise<any> =>
    makeApiCall({
      url: `/activity/activityBoqs/id/${activityId}`,
      method: "get",
    }),
  fetchWorkCatgoriesList: (): Promise<any> =>
    makeApiCall({ url: "/masters/workCatgoriesList", method: "get" }),
  fetchActivityResources: (activityId: string): Promise<any> =>
    makeApiCall({
      url: `/activity/activityResources/id/${activityId}`,
      method: "get",
    }),
  fetchTaskResources: (taskId: number): Promise<any> =>
    makeApiCall({
      url: `/task/taskResources/id/${taskId}`,
      method: "get",
    }),
  fetchTaskTools: (taskId: number): Promise<any> =>
    makeApiCall({
      url: `/task/taskTools/id/${taskId}`,
      method: "get",
    }),
  fetchProjectTags: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/project/fetchProjectTags/${projectId}`,
      method: "get",
    });
  },
  fetchTaskPredecessors: (params: any): Promise<any> =>
    makeApiCall({
      url: `/task/predecessors`,
      method: "get",
      params,
    }),
  fetchTaskSuccessors: (params: any): Promise<any> =>
    makeApiCall({
      url: `/task/successors`,
      method: "get",
      params,
    }),
  fetchTaskDropDown: (params: any): Promise<any> =>
    makeApiCall({
      url: `/task/dropdown`,
      method: "get",
      params,
    }),
  createTaskDependency: (data: any): Promise<any> =>
    makeApiCall({ url: "/task/createTaskDependency", method: "post", data }),
  updateTaskDependency: (data: any): Promise<any> =>
    makeApiCall({ url: "/task/updateTaskDependency", method: "patch", data }),
  fetchGanttView: (projectId: any, gantType: any, params: any): Promise<any> =>
    makeApiCall({
      url: `/task/groupByGanttList/${projectId}/${gantType}`,
      method: "get",
      params,
    }),
  fetchKanbanView: (projectId: any, params: any): Promise<any> =>
    makeApiCall({
      url: `/task/groupByList/${projectId}`,
      method: "get",
      params,
    }),

  fetchTaskById: (taskId: number, status: string): Promise<any> =>
    makeApiCall({
      url: `/task/id/${taskId}`,
      method: "get",
      params: {
        derivedProjectStatus: status,
      },
    }),
  statusChangeTask: (
    taskId: number,
    statusOrPercentage: string | number,
    extras?: {
      taskOnholdReason?: string;
      taskETAResolution?: string;
      executedRate?: number;
      rateRemarks?: string;
    }
  ): Promise<any> =>
    makeApiCall({
      url: `/task/statusChange/${taskId}`,
      method: "patch",
      params:
        typeof statusOrPercentage === "number"
          ? { completionPercentage: statusOrPercentage }
          : {
              status: statusOrPercentage,
              ...(extras || {}),
            },
    }),
  SubTaskstatusList: (
    taskId: number,
    statusOrPercentage: string | number,
    extras?: {
      taskOnholdReason?: string;
      taskETAResolution?: string;
    }
  ): Promise<any> =>
    makeApiCall({
      url: `/subtask/statusChange/${taskId}`,
      method: "patch",
      params:
        typeof statusOrPercentage === "number"
          ? { completionPercentage: statusOrPercentage }
          : {
              status: statusOrPercentage,
              ...(extras || {}),
            },
    }),
  fetchSubtaskDetailsById: (
    subtaskId: number,
    derivedProjectStatus?: string
  ): Promise<any> =>
    makeApiCall({
      url: `/subtask/id/${subtaskId}`,
      method: "get",
      params: { derivedProjectStatus },
    }),
  updateSubTaskbyId: (data: any): Promise<any> =>
    makeApiCall({ url: "/subtask/update", method: "patch", data }),

  fetchTaskStatusList: (moduleType: any): Promise<any> =>
    makeApiCall({
      url: `/project/allStatus/module/${moduleType}`,
      method: "get",
    }),
  fetchTaskCheckList: (): Promise<any> =>
    makeApiCall({
      url: "/CheckList/dropdown/",
      method: "get",
    }),
  fetchCheckListById: (checklistId: any): Promise<any> =>
    makeApiCall({
      url: `/Checklist/id/${checklistId}`,
      method: "get",
    }),
  submitChecklistAnswers: (data: any): Promise<any> =>
    makeApiCall({ url: "/checklist/answer/create", method: "post", data }),
  fetchChecklistAnswersByLinkId: (checklistLinkId: number): Promise<any> =>
    makeApiCall({
      url: `/checklist/answer/${checklistLinkId}`,
      method: "get",
    }),
  updateChecklistAnswers: (data: any): Promise<any> =>
    makeApiCall({ url: "/checklist/answer/update", method: "put", data }),
  createBaseLine: (data: any): Promise<any> =>
    makeApiCall({ url: "/task/createBaseline", method: "post", data }),
  fetchBaselines: (projectId: any): Promise<any> =>
    makeApiCall({
      url: `/task/baselineList/${projectId}`,
      method: "get",
    }),
  updateBaseLine: (data: any): Promise<any> =>
    makeApiCall({ url: "/task/updateBaseline", method: "patch", data }),
  deleteBaseLine: (data: any): Promise<any> =>
    makeApiCall({ url: "/task/deleteBaseline", method: "delete", data }),
  fetchTaskStatusTimeline: (projectId: number, entityId: any): Promise<any> => {
    return makeApiCall({
      url: `/task/fetchStatusTimelines/${projectId}/Task/${entityId}`,
      method: "get",
    });
  },
  fetchTaskActivityStreamlines: (
    projectId: number,
    entityId: any
  ): Promise<any> => {
    return makeApiCall({
      url: `/activity/fetchActivityStreamlines/${projectId}/Task/${entityId}`,
      method: "get",
    });
  },

  workUom: (params: any): Promise<any> =>
    makeApiCall({
      url: `/masters/workUomsList`,
      method: "get",
      params,
    }),

  getOwnersFilterData: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/task/filters/owners`,
      method: "get",
      params: { projectIds: projectId },
    });
  },
  fetchTaskWithAcitivityPhase: (projectId: any): Promise<any> => {
    return makeApiCall({
      url: `/project/wbs/${projectId}`,
      method: "get",
    });
  },
  uploadTaskBOQ: (data: any): Promise<any> =>
    makeApiCall({ url: "/task/upload/taskBoqExcel", method: "post", data }),

  uploadTaskBudget: (data: any): Promise<any> =>
    makeApiCall({ url: "/task/upload/taskBudgetExcel", method: "post", data }),

  uploadTaskResource: (data: any): Promise<any> =>
    makeApiCall({ url: "/task/upload/taskResourceExcel", method: "post", data }),

  uploadTaskTool: (data: any): Promise<any> =>
    makeApiCall({ url: "/task/upload/taskToolExcel", method: "post", data }),

  fetchToolsAndMachineryTypes: (): Promise<any> =>
    makeApiCall({
      url: "/buyer/fetchToolsAndMachineryTypesDropDown",
      method: "get",
    }),

  fetchToolsAndMachinery: (): Promise<any> =>
    makeApiCall({
      url: "/buyer/fetchToolsAndMachineryDropDown",
      method: "get",
    }),

  fetchMachineryMaterialDropDown: (): Promise<any> =>
    makeApiCall({
      url: "/buyer/fetchMachineryMaterialDropDown",
      method: "get",
    }),

  fetchMachinerySubMaterialDropDown: (materialId?: number): Promise<any> =>
    makeApiCall({
      url: "/buyer/fetchMachinerySubMaterialDropDown",
      method: "get",
      params: materialId ? { materialId } : {},
    }),

  getActivityTaskWeightage: (
    projectId: number,
    activityId?: number,
    phaseId?: number
  ): Promise<any> =>
    makeApiCall({
      url: `/task/activityTaskWeightage`,
      method: "get",
      params: { projectId, activityId, phaseId },
    }),
};
